import React, { Component } from 'react';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import { trackEvent } from 'react-with-analytics';
import { parseString } from 'xml2js'

import ZigZag from './ZigZag';
import Addresses from './Addresses';
import FormulaireDeDevis from './FormulaireDeDevis'
import FormulaireDeContact from './FormulaireDeContact'

import '../css/components/Header.css';

import imageLogo from '../images/logo.jpg';
import imageMenu from '../images/menu.jpg';

import imageFleche from '../images/fleche.png';
import imageQuoteGauche from '../images/quote-gauche.png';
import imageQuoteDroite from '../images/quote-droite.png';

import imageFacebook from '../images/facebook.png';
import imageTwitter from '../images/twitter.png';
import imageLinkedin from '../images/linkedin.png';
import Axios from 'axios';
import FormulaireDeRecrutement from "./FormulaireDeRecrutement";

class Header extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showMenu: false,
            showForm: false,
            showFormContact: false,
            showFormRecrutement: false,
            blog: {
            },
        };

        this.toggleMenu = this.toggleMenu.bind(this);
        this.doShowForm = this.doShowForm.bind(this);
        this.doShowFormMenu = this.doShowFormMenu.bind(this);
        this.doShowFormRecrutement = this.doShowFormRecrutement.bind(this);
        this.doHideForm = this.doHideForm.bind(this);
        this.doHideFormContact = this.doHideFormContact.bind(this);
        this.doHideFormRecrutement = this.doHideFormRecrutement.bind(this);
        this.getLastBlog = this.getLastBlog.bind(this);

        this.getLastBlog();
    }

    getLastBlog() {
        const rssFeed = '/blog-feed'
        Axios.get(rssFeed).then(({data}) => {
            parseString(data, (_, result) => {
                const item = result.rss.channel[0].item[0]

                const date = new Date(item.pubDate[0])
                this.setState({
                    blog: {
                        title: item.title[0],
                        url: item.link[0],
                        date: date.toLocaleDateString()
                    }
                })
            })
        })
    }

    toggleMenu() {
        let newValue = !this.state.showMenu;
        this.setState( { showMenu: newValue } );
    }

    doShowForm() {
        trackEvent('Interactions', 'Ouverture de formulaire', 'Devis Header');
        this.setState( { showForm: true } );
    }

    doShowFormMenu() {
        trackEvent('Interactions', 'Ouverture de formulaire', 'Contact Menu');
        this.setState( { showFormContact: true } );
    }

    doShowFormRecrutement() {
        trackEvent('Interactions', 'Ouverture de formulaire', 'Recrutement Agence');
        this.setState( { showFormRecrutement: true } );
    }

    doHideForm() {
        this.setState( { showForm: false } );
    }

    doHideFormContact() {
        this.setState( { showFormContact: false } );
    }

    doHideFormRecrutement() {
        this.setState( { showFormRecrutement: false } );
    }
  render() {
    const { blog, showForm, showFormContact, showFormRecrutement, showMenu } = this.state

    return (
    <header>
        <section>
            <NavLink to="/"><img src={imageLogo} alt="logo" title="ARCA Computing" className="logo" /></NavLink>
            <p>
                {
                    blog.url 
                    ? <a href={blog.url}><img className="quote-gauche" src={imageQuoteGauche} alt="" /><strong>{blog.date}</strong> : {blog.title} <img src={imageFleche} alt="" /><img className="quote-droite" src={imageQuoteDroite} alt="" /></a>
                    : null 
                }
            </p>
            <div onClick={this.doShowFormRecrutement} className="btn btn-pink">Nous recrutons !</div>
            <div onClick={this.toggleMenu}><img src={imageMenu} alt="menu" className="menu-icon" /></div>
            <FormulaireDeDevis show={showForm} onCancel={this.doHideForm} />
            <FormulaireDeContact show={showFormContact} onCancel={this.doHideFormContact} />
            <FormulaireDeRecrutement show={showFormRecrutement} onCancel={this.doHideFormRecrutement} />
        </section>
        {
            showMenu === true ? (
                <div className="menu">
                    <nav>
                        <div className="nav-wrapper">
                            <ZigZag />
                            <NavLink to="/" onClick={this.toggleMenu}>Accueil</NavLink>
                            <NavLink to="/agence" onClick={this.toggleMenu}>Les agences</NavLink>
                            <NavLink to="/methode" onClick={this.toggleMenu}>Notre méthode</NavLink>
                            <NavLink to="/projets" onClick={this.toggleMenu}>Les projets</NavLink>
                            <div className="link" onClick={() => { this.toggleMenu(); this.doShowFormMenu(); }}>Contact</div>
                            <a href="https://blog.arca-computing.fr/">Actualités</a>
                            <div className="link" onClick={() => { this.toggleMenu(); this.doShowFormRecrutement(); }}>Recrutement</div>
                            <ZigZag />
                        </div>

                        <Addresses />

                        <div className="menu-bottom">
                            <div className="social">
                                <a href="https://www.facebook.com/arcacomputing/"><img src={imageFacebook} className="fb" alt="facebook" /></a>
                                <a href="https://twitter.com/arcacomputing?lang=fr"><img src={imageTwitter} className="twitter" alt="twitter" /></a>
                                <a href="https://www.linkedin.com/company/arca-computing/"><img src={imageLinkedin} className="link" alt="linkedin" /></a>
                            </div>
                            <div className="copyright">
                                <div>2018 &#169; ARCA Computing - Tous droits réservés</div>
                                <div><NavLink to="/mentions" onClick={this.toggleMenu}>Mentions légales</NavLink></div>
                            </div>
                        </div>
                    </nav>
                </div>
             ) : null
        }
    </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js